import { Component } from "@angular/core";

@Component({
  selector: "app-nca-sign-popup",
  templateUrl: "./nca-sign-popup.component.html",
  styleUrls: ["./nca-sign-popup.component.scss"]
})
export class NcaSignPopupComponent {
}
